import { ErrorBoundary } from 'components/common/error-boundary';
import { useActiveRoute } from 'hooks/useActiveRoute';
import { useNavSections } from 'hooks/useNavSections';
import { useNavigate } from 'react-router-dom';
import { SidebarNavigationTrigger } from './nav-trigger';

const COMPONENT_NAME = 'UserSections';

export const UserSections = () => {
  const navigate = useNavigate();
  const { userSections } = useNavSections();

  const { section: activeSection, subsection: activeSubsection } =
    useActiveRoute();

  return (
    <ErrorBoundary identifier={COMPONENT_NAME}>
      {userSections
        .filter((s) => !s.invisible)
        .map((s, i) => (
          <SidebarNavigationTrigger
            key={`user-section-${i}`}
            active={activeSection === s.value}
            label={s.label}
            icon={<s.icon />}
            onClick={() => {
              const defaultSubsection = s.subsections?.find((ss) => ss.default);

              if (s.value !== activeSection) {
                navigate(defaultSubsection?.to ?? s.to);
                return;
              }

              if (
                defaultSubsection &&
                defaultSubsection.value !== activeSubsection
              ) {
                navigate(defaultSubsection.to);
              }
            }}
          />
        ))}
    </ErrorBoundary>
  );
};
